export default __webpack_public_path__ + "static/media/community.e1dfbe3b.jpeg";